import type { Translate } from '@client-app/i18n';

const ROLE_LABEL_TRANSLATION_KEYS: Record<string, string> = {
    OWNER: 'website.membersSettings.ownerRole',
    ADMIN: 'website.membersSettings.adminRole',
    BILLING: 'website.membersSettings.billingRole',
    MEMBER: 'website.membersSettings.memberRole',
    ECOMMERCE_OPS: 'website.membersSettings.ecommerceOpsRole',
    'ECOMMERCE OPERATIONS': 'website.membersSettings.ecommerceOpsRole',
    PAID_MEDIA: 'website.membersSettings.paidMediaRole',
    'PAID MEDIA & CHANNEL GROWTH': 'website.membersSettings.paidMediaRole',
    SEO_CONTENT: 'website.membersSettings.seoContentRole',
    'SEO & CONTENT GROWTH': 'website.membersSettings.seoContentRole',
    SOCIAL_INFLUENCER: 'website.membersSettings.socialInfluencerRole',
    'SOCIAL & INFLUENCER OPS': 'website.membersSettings.socialInfluencerRole',
    CRM_LIFECYCLE: 'website.membersSettings.crmLifecycleRole',
    'CRM & LIFECYCLE MARKETING': 'website.membersSettings.crmLifecycleRole',
    BUSINESS_INSIGHTS: 'website.membersSettings.businessInsightsRole',
    'BUSINESS ANALYTICS & INSIGHTS': 'website.membersSettings.businessInsightsRole',
    SITE_EXPERIENCE: 'website.membersSettings.siteExperienceRole',
    'SITE EXPERIENCE & QA': 'website.membersSettings.siteExperienceRole',
};

const normalizeRoleLabelKey = (role: string | null | undefined) =>
    String(role || '').trim().toUpperCase();

const toTitleCaseRoleLabel = (role: string) =>
    role
        .trim()
        .split(/\s+/)
        .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join(' ');

export const formatRoleLabel = (
    role?: string | null,
    t?: Translate,
    options: { titleCaseFallback?: boolean } = {}
) => {
    if (!role) return '';

    const translationKey = ROLE_LABEL_TRANSLATION_KEYS[normalizeRoleLabelKey(role)];
    if (t && translationKey) {
        return t(translationKey);
    }

    return options.titleCaseFallback ? toTitleCaseRoleLabel(role) : role.trim();
};
